import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import { platformSelectors } from '@clatter/platform';
import { Breadcrumbs, EditableTextElement, InfoTooltip, Ribbon } from '../../index';
import styled from 'styled-components';
import classNames from 'classnames';

const StyledPageTitle = styled.h2`
  display: flex;
  gap: 10px;
  font-size: 24px;
  color: #000000;
  text-decoration: none;
  font-weight: 700;
  margin-bottom: 1.5rem;

  &.no-margin {
    margin-bottom: 0;
  }
`;

const renderTitle = ({ helpLink, pageTitle, pageTitlePrefix, noMargin }) => {
  const title = pageTitlePrefix ? `${pageTitlePrefix} ${pageTitle}` : pageTitle;
  return helpLink ? (
    <InfoTooltip title="Help link" tooltipText="Documentation" externalUrl={helpLink} hideTooltip={!helpLink}>
      <StyledPageTitle className={classNames({ 'no-margin': noMargin })}>{title}</StyledPageTitle>
    </InfoTooltip>
  ) : (
    <StyledPageTitle className={classNames({ 'no-margin': noMargin })}>{title}</StyledPageTitle>
  );
};

const PageTitleHeader = ({
  headerActions,
  secondaryContent,
  pageTitle,
  noMargin,
  links,
  type,
  ribbonActions,
  disableDivider,
  text,
  titleOptions,
  pageTitlePrefix,
}) => {
  const location = useLocation();
  const helpjuiceLinks = useSelector(platformSelectors.toolInfo.selectToolInfo)?.data?.helpjuiceLinks || {};

  if (type === 'ribbon') {
    return (
      <Grid container>
        <Grid size={12} sx={{ mb: 2 }}>
          <Breadcrumbs links={links} pageTitle={pageTitle} />
        </Grid>
        <Grid size={12}>
          <Ribbon
            pageTitle={renderTitle({
              pageTitle: pageTitle,
              helpLink: helpjuiceLinks[location?.pathname],
              noMargin: noMargin,
              pageTitlePrefix: pageTitlePrefix,
            })}
            text={text}
            disableDivider={disableDivider}
            ribbonActions={ribbonActions}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Grid container sx={{ mb: 2 }}>
        <Grid size={12} sx={{ mb: 2 }}>
          <Breadcrumbs links={links} pageTitle={pageTitle} />
        </Grid>

        <Grid container size={12} sx={{ justifyContent: "space-between" }}>
          <Grid size="auto">
            {titleOptions?.editable ? (
              <EditableTextElement
                label={titleOptions?.label}
                initialValue={titleOptions?.titleInitialValue}
                onTextChange={titleOptions?.onTitleChange}
                customValidator={titleOptions?.customValidator}
              >
                {renderTitle({
                  pageTitle: pageTitle,
                  helpLink: helpjuiceLinks[location?.pathname],
                  noMargin: true,
                  pageTitlePrefix: pageTitlePrefix,
                })}
              </EditableTextElement>
            ) : (
              renderTitle({
                pageTitle: pageTitle,
                helpLink: helpjuiceLinks[location?.pathname],
                noMargin: noMargin,
                pageTitlePrefix: pageTitlePrefix,
              })
            )}
          </Grid>
          {headerActions && <Grid size="auto">{headerActions}</Grid>}
        </Grid>
        {secondaryContent && (
          <Grid size={12}>
            {secondaryContent}
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default PageTitleHeader;
